export const getRotationToSave = rot => {
  const rotation = parseInt(rot, 10);
  if (rotation > 359) return rotation % 360;
  if (rotation < 0) return 359;
  return rotation;
};
